// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_b5-4";
export var collapsed = "_b5-1";
export var headerBar = "_b5-0";
export var leftHeaderContent = "_b5-3";
export var subjectContainer = "_b5-2";